define('gumbo-js-client-lib/forms/liveData/PlayForm',['require','exports','module','jquery','./AtbatForm'],function(require, exports, module) {
	var $ = require("jquery"),
		atbatFormat = require("./AtbatForm");

	return {
		about: {
			atBatIndex: null,
			halfInning: null,
			inning: null,
			startTfs: null,
			isComplete: null,
			isScoringPlay: null
		},
		count: {
			balls: null,
			strikes: null,
			outs: null,
			numPitches: null
		},
		matchup: {
			batter: null,
			pitcher: null,
			batterHotColdZones: null,
			splits: {
				batter: null,
				menOnBase: null,
				pitcher: null
			}
		},
		result: {
			type: null,
			event: null,
			box: null,
			ball: null
		},
		pitchEvents: null,
		actions : null
	}
});
